import React, { useState } from "react";
import { useRef } from "react";
import {
  makeStyles,
  Theme,
  createStyles,
  withStyles,
} from "@material-ui/core/styles";
import Button from '@mui/material/Button';
import { connect } from "react-redux";
import { Paper, TextField, Grid } from "@material-ui/core";
import { useEffect } from "react"
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Link, useNavigate, useParams } from "react-router-dom";
import { TableFooter, TablePagination } from "@material-ui/core";
import { generateCxFilterUrl } from "../../helpers/generateUrl";
import {
  getAllNewBookings,
} from "../../LimsAdmin-Panel/actions/LimsAdminActions";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    table: {
      minWidth: 700,
    },
    toolbar: {
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(0, 1),
      ...theme.mixins.toolbar,
    },
    content: {
      width: "80%",
      flexGrow: 21,
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    paper: {
      marginTop: "2rem",
      padding: "0.5rem 2rem 2rem 2rem",
      width: "100%",
    },
    contentHeader: {
      width: "100%",
      padding: "0px 10px 40px 10px",
      minHeight: "64px",
    },
    leftContentHeader: {
      width: "50%",
      float: "left",
    },
    rightContentHeader: {
      width: "50%",
      float: "right",
      textAlign: "right",
      paddingRight: "20px",
    },
    buttonContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    head: {
      textAlign: "center",
      fontWeight: "normal",
      marginBottom: "2rem",
    },
    slotContainer: {
      width: "100%",
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: "center",
    },
    slot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      margin: "0.5rem",
    },
    hoveItem: {
      cursor: "pointer",
    },
    selectedSlot: {
      width: "150px",
      height: "100px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(60deg, cyan, #00dfff, cyan)",
      cursor: "pointer",
      margin: "0.5rem",
    },
    chips: {
      display: "flex",
    },
    chip: {
      margin: 2,
      background: "linear-gradient(60deg, cyan, #00cfff, cyan)",
      maxWidth: "130px",
    },
    input: {
      padding: "1px",
    },
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
    tableHead: {
      background: "rgb(146, 74, 145)!important",
    },
    tableHeadCell: {
      color: "#fff",
      fontWeight: "bold",
      textAlign: "center",
    },
    centerIt: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  })
);

const StyledTableCell: any = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: "#1C4E80",
      color: theme.palette.common.white,
      fontSize: "14px",
    },
    body: {
      fontSize: 14,
    },
  })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);
interface Props {
  getAllNewBookings: any;
  bookingList: any;
  loading: any;
}
const StopsPlace: React.FC<Props> = ({
  getAllNewBookings,
  bookingList,
  loading,
}) => {
  const classes = useStyles();
  // const history = useHistory();
  const timer = useRef<any>(0);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [manager, setManager] = useState<any>("");
  const [userId, setUserId] = useState<any>("");
  const [emailId, setEmailId] = useState<any>("");
  const [phone, setPhone] = useState<any>("");

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url = bookingList?.links && bookingList?.links.next.split("?")[1];
      getAllNewBookings(url);
    } else if (newPage < page) {
      let url = bookingList?.links && bookingList?.links.previous.split("?")[1];
      getAllNewBookings(url);
    }
    setPage(newPage as number);
  };

  useEffect(() => {
    getAllNewBookings();
  }, [])


  return (
    <Grid container spacing={2} style={{ marginTop: 50 }}>
      <Grid item xs={10}>
        <h4 style={{ fontWeight: "bold" }}>LIMS ADMIN</h4>
      </Grid>
      <form style={{ width: "100%" }}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              label="Booking Id"
              variant="outlined"
              className="input"
              fullWidth
              type="number"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              label="Patient Name"
              variant="outlined"
              className="input"
              fullWidth
              value={manager}
              onChange={(e) => setManager(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              label="Email ID"
              variant="outlined"
              className="input"
              fullWidth
              value={emailId}
              onChange={(e) => setEmailId(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              label="Phone No"
              variant="outlined"
              className="input"
              fullWidth
              type="number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Button
              color="primary"
              variant="contained"
              fullWidth
              type="submit"
              style={{ height: "100%" }}
            // onClick={filterAttendence}
            >
              Filter
            </Button>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Button
              color="secondary"
              variant="contained"
              fullWidth
              // onClick={() => history.push("/dashboard/lp/manageManger")}
              style={{ height: "100%" }}
            >
              reset
            </Button>
          </Grid>
        </Grid>
        <TableContainer className={classes.tableContainer} component={Paper} style={{ maxHeight: "550px" }}>
          <Table stickyHeader aria-label="simple table">
            <TableHead className={classes.tableHead}>
              <StyledTableRow>
                <StyledTableCell align="center">Action</StyledTableCell>
                <StyledTableCell align="center">Booking Id</StyledTableCell>
                <StyledTableCell align="center">Patient Name</StyledTableCell>
                <StyledTableCell align="center">Collection Date</StyledTableCell>
                <StyledTableCell align="center">City</StyledTableCell>
                <StyledTableCell align="center">Booking Status</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {bookingList && bookingList?.results && bookingList?.results?.length > 0 && bookingList?.results?.map((data: any, index: any) => {
                return (
                  <StyledTableRow >
                    <StyledTableCell align="center">
                      <Link
                        to={`/dashboard/la/report/${data.id}`}
                        style={{ textDecoration: "none" }}
                      >
                        <Button
                          variant="contained"
                          style={{
                            background: "#1976d2",
                            marginLeft: "1rem",
                            marginBottom: "1rem",
                          }}
                        >
                          Create Nbs Report
                        </Button>
                      </Link>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.id}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.customer_name}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.collection_date}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.city}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {data?.booking_status}
                    </StyledTableCell>
                  </StyledTableRow>
                )
              })}
            </TableBody>
            <TableFooter>
              <StyledTableRow>
                <TablePagination
                  rowsPerPageOptions={[]}
                  colSpan={3}
                  count={bookingList?.count || 0}
                  rowsPerPage={bookingList?.page_size}
                  page={page}
                  onPageChange={handleChangePage}
                />
              </StyledTableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </form>
    </Grid>
  );
};
const mapStateToProps = (state: any) => ({
  bookingList: state.LimsAdminReducer.bookingList,
});
export default connect(mapStateToProps, {
  getAllNewBookings,

})(StopsPlace);
